export const COUNTRY_CODES = ['austria', 'germany', 'switzerland'] as const;

export declare type CountryCode = typeof COUNTRY_CODES[number];
